import { sendSignatureToServer } from '../../../shared/data-services/newsletter-service';
import { callAPI } from '../../../shared/network';

export async function sendSignature (signatureId, signature,employeeId){

    const data = await sendSignatureToServer(
                         signatureId,signature,employeeId);
    return data || [];
 };


 export async function getPendingNewslettersByEmployee (employeeId,handleError){
  
    const data = await callAPI(
       null, 
             'Newsletter/getPendingNewslettersByEmployeeId?employeeId='+ employeeId, 'get',handleError);
    
    return data || [];
 };